import React, { Component } from "react";

class Groepsgericht extends Component {
  constructor(props) {
    super(props);

    this.state = {
      case: props.case,
      case2: props.case2,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.case !== this.props.case && this.props.case !== undefined) {
      this.setState({ case: this.props.case });
    }
  }

  render() {
    return (
      <>
        {" "}
        {/* pregunta aditional*/}
        <form className="flex justify-between items-start w-1/2 my-3">
          {this.props.SelectField(
            "Hoe oud ben je :",
            "hoeoud",
            [
              {
                value: 46822,
                label: "18 jaar en ouder (tot 23)",
              },
              {
                value: 46821,
                label: "13 - 17 jaar",
              },
              {
                value: 46820,
                label: "10 - 12 jaar",
              },
            ],
            {
              required: true,
            }
          )}
        </form>
        {/* Caso Groepsgericht */}
        {/* <form className="flex justify-between items-start">
          {this.props.handleSelectField(
            "Groepsgericht:",
            "groepsgericht",
            [
              {
                value: 46661,
                label: "Groepswerk (activiteiten)",
              },
              {
                value: 46660,
                label: "Talentonwikkeling (workshops)",
              },
              {
                value: 46659,
                label: "Inloop",
              },
              {
                value: 46658,
                label: "Meidenwerk",
              },
            ],
            {
              required: true,
            }
          )}
        </form> */}
        {/*Caso 1 Groepsgericht*/}
        {this.state.case === 1 ||
        this.state.case2 === "Groepswerk (activiteiten)" ? (
          <form className="grid grid-cols-2 gap-3 mt-3">
            {this.props.SelectFieldStar(
              "Ontmoet je bij onze activiteiten vrienden?",
              "groepsgericht_1",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Heb je nieuwe vrienden gemaakt?",
              "groepsgericht_2",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Doe je nu meer mee aan activiteiten? ",
              "groepsgericht_3",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Praat je over dingen die voor jou belangrijk zijn tijdens de activiteiten of met de jongerenwerker?",
              "groepsgericht_4",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ervaar je dat anderen naar je luisteren?",
              "groepsgericht_5",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Vraag je om hulp als je het nodig hebt?",
              "groepsgericht_6",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Wordt je goed geholpen door de jongerenwerker?  ",
              "groepsgericht_7",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb vertrouwen in wat ik kan en doe",
              "groepsgericht_8",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik maak mijn eigen keuzes ",
              "groepsgericht_9",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb vertrouwen in mijn eigen keuzes ",
              "groepsgericht_10",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
          </form>
        ) : null}
        {/*Caso 2 Talentonwikkeling (workshops)*/}
        {this.state.case === 2 ||
        this.state.case2 === "Talentonwikkeling (workshops)" ? (
          <form className="grid grid-cols-2 gap-3 mt-3">
            {this.props.SelectFieldStar(
              "Help je anderen bij de activiteiten?",
              "talentonwikkeling_1",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Voel je je gesteund door andere jongeren?",
              "talentonwikkeling_2",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Helpen jullie elkaar in de groep?",
              "talentonwikkeling_3",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb door de activiteiten ontdekt waar ik goed in ben (bijv. sport, muziek, leiderschap)?",
              "talentonwikkeling_4",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb nieuwe dingen geleerd en gebruik die ook  ",
              "talentonwikkeling_5",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb succes met waarin ik me ontwikkeld heb",
              "talentonwikkeling_6",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb vertrouwen in wat ik kan en doe  ",
              "talentonwikkeling_7",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik maak mijn eigen keuzes",
              "talentonwikkeling_8",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb vertrouwen in mijn eigen keuzes  ",
              "talentonwikkeling_9",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
          </form>
        ) : null}
        {/*Caso 3 Inloop*/}
        {this.state.case === 3 || this.state.case2 === "Inloop" ? (
          <form className="grid grid-cols-2 gap-3 mt-3">
            {this.props.SelectFieldStar(
              "Ontmoet je bij onze activiteiten vrienden?",
              "inloop_1",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Doe je nu meer mee aan activiteiten?",
              "inloop_2",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Kun je goed vertellen wat je denkt en voelt bij de activiteiten?",
              "inloop_3",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Los je ruzies met anderen goed op? ",
              "inloop_4",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Vind je het makkelijk om samen te werken met anderen? ",
              "inloop_5",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Deel je met de jongerenwerkers wat je bezig houdt?",
              "inloop_6",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Voel je je door de jongerenwerker gezien en gehoord?  ",
              "inloop_7",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Durf je de jongerenwerker om hulp te vragen?  ",
              "inloop_8",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Heeft de jongerenwerker je verder geholpen?",
              "inloop_9",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
          </form>
        ) : null}
        {/*Caso 3 Meidenwerk*/}
        {this.state.case === 4 || this.state.case2 === "Meidenwerk" ? (
          <form className="grid grid-cols-2 gap-3 mt-3">
            {this.props.SelectFieldStar(
              "Kun je goed vertellen wat je denkt en voelt bij de activiteiten?",
              "meidenwerk_1",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Los je ruzies met anderen goed op?  ",
              "meidenwerk_2",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Vind je het makkelijk om samen te werken met anderen?  ",
              "meidenwerk_3",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb door de activiteiten ontdekt waar ik goed in ben (bijv. sport, muziek, leiderschap)?",
              "meidenwerk_4",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb nieuwe dingen geleerd en gebruik die ook ",
              "meidenwerk_5",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb succes met waarin ik me ontwikkeld heb  ",
              "meidenwerk_6",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik help mee met de activiteiten.  ",
              "meidenwerk_7",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb zelf activiteiten mee georganiseerd.  ",
              "meidenwerk_8",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectField(
              "Ik heb iets gedaan voor anderen in de buurt (ja-nee)",
              "meidenwerk_9",
              [
                {
                  value: 46670,
                  label: "Nee",
                },
                {
                  value: 46669,
                  label: "Ja",
                },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectField(
              "Ik ben vrijwilliger bij Dynamo (ja-nee)",
              "meidenwerk_10",
              [
                {
                  value: 46670,
                  label: "Nee",
                },
                {
                  value: 46669,
                  label: "Ja",
                },
              ],
              {
                required: true,
              }
            )}
            {this.props.opt8
              ? this.props.SelectField(
                  "Nog niet? Ik wil wel vrjwilliger worden (ja-nee)",
                  "meidenwerk_11",
                  [
                    { value: 46670, label: "Nee" },
                    { value: 46669, label: "Ja" },
                  ],
                  { required: true }
                )
              : null}
          </form>
        ) : null}
        {/* pregunta aditional*/}
        <form className="flex justify-between items-start w-11/12 my-4">
          {this.props.TextAreaField(
            "Wat zou je zelf nog kwijt willen aan Dynamo over ons en de jongerenwerkers?",
            "woorden",
            {}
          )}
        </form>
      </>
    );
  }
}

export default Groepsgericht;
